const data = {
  title: "Floor 3-6",
  musicTrack: "MUSIC_WORLD3",
  theme: "PINK",
  tilesWidth: 13,
  tilesHeight: 13,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 3,
      y: 7
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 11,
      y: 7
    },
    {
      type: "WATER",
      x: 1,
      y: 1
    },
    {
      type: "WATER",
      x: 2,
      y: 1
    },
    {
      type: "WATER",
      x: 3,
      y: 1
    },
    {
      type: "WATER",
      x: 4,
      y: 1
    },
    {
      type: "WATER",
      x: 5,
      y: 1
    },
    {
      type: "WATER",
      x: 6,
      y: 1
    },
    {
      type: "WATER",
      x: 7,
      y: 1
    },
    {
      type: "WATER",
      x: 8,
      y: 1
    },
    {
      type: "WATER",
      x: 9,
      y: 1
    },
    {
      type: "WATER",
      x: 10,
      y: 1
    },
    {
      type: "WATER",
      x: 11,
      y: 1
    },
    {
      type: "WATER",
      x: 12,
      y: 1
    },
    {
      type: "WATER",
      x: 13,
      y: 1
    },
    {
      type: "WATER",
      x: 13,
      y: 2
    },
    {
      type: "WATER",
      x: 13,
      y: 3
    },
    {
      type: "WATER",
      x: 13,
      y: 4
    },
    {
      type: "WATER",
      x: 13,
      y: 5
    },
    {
      type: "WATER",
      x: 13,
      y: 6
    },
    {
      type: "WATER",
      x: 13,
      y: 7
    },
    {
      type: "WATER",
      x: 13,
      y: 8
    },
    {
      type: "WATER",
      x: 1,
      y: 2
    },
    {
      type: "WATER",
      x: 1,
      y: 3
    },
    {
      type: "WATER",
      x: 1,
      y: 4
    },
    {
      type: "WATER",
      x: 1,
      y: 5
    },
    {
      type: "WATER",
      x: 1,
      y: 6
    },
    {
      type: "WATER",
      x: 1,
      y: 7
    },
    {
      type: "WATER",
      x: 1,
      y: 8
    },
    {
      type: "WATER",
      x: 1,
      y: 10
    },
    {
      type: "WATER",
      x: 1,
      y: 11
    },
    {
      type: "WATER",
      x: 1,
      y: 12
    },
    {
      type: "WATER",
      x: 1,
      y: 13
    },
    {
      type: "WATER",
      x: 2,
      y: 13
    },
    {
      type: "WATER",
      x: 3,
      y: 13
    },
    {
      type: "WATER",
      x: 4,
      y: 13
    },
    {
      type: "WATER",
      x: 6,
      y: 13
    },
    {
      type: "WATER",
      x: 5,
      y: 13
    },
    {
      type: "WATER",
      x: 8,
      y: 13
    },
    {
      type: "WATER",
      x: 9,
      y: 13
    },
    {
      type: "WATER",
      x: 10,
      y: 13
    },
    {
      type: "WATER",
      x: 11,
      y: 13
    },
    {
      type: "WATER",
      x: 12,
      y: 13
    },
    {
      type: "WATER",
      x: 13,
      y: 13
    },
    {
      type: "WATER",
      x: 13,
      y: 12
    },
    {
      type: "WATER",
      x: 13,
      y: 11
    },
    {
      type: "WATER",
      x: 13,
      y: 10
    },
    {
      type: "ICE",
      x: 2,
      y: 10
    },
    {
      type: "ICE",
      x: 2,
      y: 12
    },
    {
      type: "ICE",
      x: 2,
      y: 11
    },
    {
      type: "ENEMY_SPAWN",
      x: 4,
      y: 2,
      direction: "DOWN",
      enemyType: "ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 5,
      y: 2,
      direction: "DOWN",
      enemyType: "ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 6,
      y: 2,
      direction: "DOWN",
      enemyType: "ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 8,
      y: 2,
      direction: "DOWN",
      enemyType: "ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 9,
      y: 2,
      direction: "DOWN",
      enemyType: "ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 10,
      y: 2,
      direction: "DOWN",
      enemyType: "ENEMY"
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 5,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 3,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 11,
      y: 3,
      isRaised: true
    },
    {
      type: "WALL",
      x: 2,
      y: 3
    },
    {
      type: "WALL",
      x: 12,
      y: 3
    },
    {
      type: "SWITCH_WALL",
      x: 11,
      y: 11,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 11,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 11,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 11,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 11,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 5,
      y: 11,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 11,
      isRaised: true
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 11,
      isRaised: true
    },
    {
      type: "ICE",
      x: 12,
      y: 10
    },
    {
      type: "ICE",
      x: 12,
      y: 12
    },
    {
      type: "ICE",
      x: 12,
      y: 11
    },
    {
      type: "WATER_PICKUP",
      x: 12,
      y: 11
    },
    {
      type: "ENEMY_SPAWN",
      x: 7,
      y: 2,
      direction: "DOWN",
      enemyType: "ENEMY"
    },
    {
      type: "SWITCH",
      x: 7,
      y: 7
    },
    {
      type: "CHIP",
      x: 3,
      y: 10
    },
    {
      type: "CHIP",
      x: 4,
      y: 10
    },
    {
      type: "CHIP",
      x: 5,
      y: 10
    },
    {
      type: "CHIP",
      x: 6,
      y: 10
    },
    {
      type: "CHIP",
      x: 8,
      y: 10
    },
    {
      type: "CHIP",
      x: 9,
      y: 10
    },
    {
      type: "CHIP",
      x: 10,
      y: 10
    },
    {
      type: "CHIP",
      x: 11,
      y: 10
    },
    {
      type: "FIRE",
      x: 6,
      y: 7
    },
    {
      type: "FIRE",
      x: 6,
      y: 6
    },
    {
      type: "FIRE",
      x: 7,
      y: 6
    },
    {
      type: "FIRE",
      x: 8,
      y: 6
    },
    {
      type: "FIRE",
      x: 8,
      y: 7
    },
    {
      type: "FIRE",
      x: 7,
      y: 8
    },
    {
      type: "FIRE",
      x: 6,
      y: 8
    },
    {
      type: "FIRE_BOOTS",
      x: 2,
      y: 11
    },
    {
      type: "THIEF",
      x: 7,
      y: 12
    },
    {
      type: "THIEF",
      x: 7,
      y: 10
    },
    {
      type: "THIEF",
      x: 7,
      y: 11
    },
    {
      type: "ENEMY_SPAWN",
      x: 3,
      y: 2,
      direction: "DOWN",
      enemyType: "ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 11,
      y: 2,
      direction: "DOWN",
      enemyType: "ENEMY"
    },
    {
      type: "FIRE",
      x: 8,
      y: 8
    },
    {
      type: "LOCK",
      x: 12,
      y: 9,
      color: "GREEN"
    },
    {
      type: "KEY",
      x: 12,
      y: 2,
      color: "BLUE"
    },
    {
      type: "KEY",
      x: 2,
      y: 2,
      color: "GREEN"
    },
    {
      type: "FIRE",
      x: 3,
      y: 9
    },
    {
      type: "FIRE",
      x: 4,
      y: 9
    },
    {
      type: "FIRE",
      x: 5,
      y: 9
    },
    {
      type: "FIRE",
      x: 6,
      y: 9
    },
    {
      type: "FIRE",
      x: 7,
      y: 9
    },
    {
      type: "FIRE",
      x: 8,
      y: 9
    },
    {
      type: "FIRE",
      x: 9,
      y: 9
    },
    {
      type: "FIRE",
      x: 10,
      y: 9
    },
    {
      type: "FIRE",
      x: 11,
      y: 9
    },
    {
      type: "WALL",
      x: 3,
      y: 6
    },
    {
      type: "WALL",
      x: 11,
      y: 6
    },
    {
      type: "WALL",
      x: 13,
      y: 9
    },
    {
      type: "WALL",
      x: 1,
      y: 9
    },
    {
      type: "WALL",
      x: 2,
      y: 9
    },
    {
      type: "LOCK",
      x: 7,
      y: 13,
      color: "BLUE"
    }
  ]
};

export default data;